import { render, staticRenderFns } from "./AppGebruikerVerificatieEmail.vue?vue&type=template&id=e801dd80&scoped=true&"
import script from "./AppGebruikerVerificatieEmail.vue?vue&type=script&lang=ts&"
export * from "./AppGebruikerVerificatieEmail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e801dd80",
  null
  
)

export default component.exports